import * as React from 'react';

import { translate } from '~l10n/client';

import { Divider } from '~shared/components/Divider';
import { ImportError } from '~teacher/components/ImportQuizBySpreadsheet/ImportError';
import {
  ImportQuizBySpreadsheetInputFile,
  Props as ImportQuizBySpreadsheetInputFileProps,
} from '~teacher/components/ImportQuizBySpreadsheet/ImportQuizBySpreadsheetInputFile';

interface Props extends ImportQuizBySpreadsheetInputFileProps {
  error: any;
}

export function ImportQuizBySpreadsheet({ error, isError, ...props }: Props) {
  return (
    <>
      <div className="my-4">
        <Divider />
      </div>
      <div className="flex flex-col gap-4">
        <label
          className="font-sans font-400 text-base text-blue-900 leading-8"
          htmlFor="spreadsheet-file-input"
          id="spreadsheet-file-input-label"
        >
          {translate('Spreadsheet')}
        </label>
        <span
          className="font-sans font-400 text-base text-blue-600 leading-8"
          id="spreadsheet-file-input-description"
        >
          {translate('Max file size: {0}. Supported file types {1}.').format(
            '1 MB',
            'xlsx'
          )}
        </span>
        <ImportQuizBySpreadsheetInputFile
          id="spreadsheet-file-input"
          aria-describedby="spreadsheet-file-input-description"
          aria-labelledby="spreadsheet-file-input-label"
          isError={isError}
          {...props}
        />
        {isError && <ImportError error={error} />}
      </div>
    </>
  );
}
